<template><div role="group" :aria-describedby="ariaDescribedby"><slot :ariaDescribedby="ariaDescribedby"></slot></div></template>
<script lang="ts">
import { computed, defineComponent, provide, toRef } from 'vue'
import { checkboxGroupKey } from './checkbox-context'
let groupId = 0
export default defineComponent({
  name: 'BFormCheckboxGroup',
  props: {
    modelValue: { type: Array, default: undefined },
    value: { type: Array, default: undefined },
    name: { type: String, default: '' },
    stacked: Boolean
  },
  emits: ['update:modelValue', 'input', 'change'],
  setup(props, { emit }) {
    const model = computed(() => (props.modelValue ?? props.value ?? []) as unknown[])
    const ariaDescribedby = `checkbox-group-${++groupId}`
    const toggle = (value: unknown, checked: boolean) => {
      const next = checked
        ? [...model.value.filter((item) => item !== value), value]
        : model.value.filter((item) => item !== value)
      emit('update:modelValue', next)
      emit('input', next)
      emit('change', next)
    }
    provide(checkboxGroupKey, { model, name: toRef(props, 'name'), toggle })
    return { ariaDescribedby }
  }
})
</script>
